import Vue from 'vue'
import api from '@/api'
import { LANG_VAR_LOCAL_STORAGE_KEY, getDefaultLang } from '@/util/consts'

const PROFEED = 'profeed'
const ANIMALFEED = 'animalfeed'

const TOKEN_KEY = 't'
const USER_TYPE_KEY = 'user_type'
const MODULES_KEY = 'modules'

const SET_AUTH = 'SET_AUTH'
const SET_USER_TYPE = 'SET_USER_TYPE'
const SET_MODULES = 'SET_MODULES'
const SET_TIMEZONE = 'SET_TIMEZONE'
const SET_LANG = 'SET_LANG'


const initModules = () => {
  const local = localStorage.getItem(MODULES_KEY)
  if (local) {
    return local.split(',')
  }
  return [PROFEED]
}

export default {
  namespaced: true,

  state () {
    return {
      auth: false,
      timezone: 'UTC',
      lang: getDefaultLang(),
      type: localStorage.getItem(USER_TYPE_KEY) || null,
      modules: initModules()
    }
  },

  getters: {
    type: (state) => state.type,
    timezone: (state) => state.timezone,
    lang: (state) => state.lang,
    isAuth: (state) => state.auth,
    isAdmin: (state) => state.type === 'admin',
    isConsultant: (state) => state.type === 'consultant' || state.type === null,
    isStaff: (state) => state.type === 'staff',
    isClient: (state) => ['client', 'employee'].includes(state.type),
    hasProfeed: (state) => state.modules.some(item => item === PROFEED),
    hasAnimalfeed: (state) => state.modules.some(item => item === ANIMALFEED)
  },

  mutations: {
    [SET_AUTH] (state, value) {
      state.auth = value
    },

    [SET_USER_TYPE] (state, value) {
      state.type = value
      localStorage.setItem(USER_TYPE_KEY, value)
    },

    [SET_MODULES] (state, value) {
      state.modules = value
      localStorage.setItem(MODULES_KEY, value)
    },

    [SET_TIMEZONE] (state, value) {
      state.timezone = value
    },

    [SET_LANG] (state, value) {
      state.lang = value
      localStorage.setItem(LANG_VAR_LOCAL_STORAGE_KEY, value)
    }
  },

  actions: {
    async init ({ state, getters, commit, dispatch }) {
      const verified = await dispatch('verifyToken')
      if (verified) {
        setTimeout(() => { dispatch('verifyToken') }, 1000 * 60 * 25)
        if (!getters.isAdmin) {
          await dispatch('permissions/loadPermissions', null, { root: true })
        }
      }
      commit(SET_AUTH, !!verified)
      return { isAuth: state.auth }
    },

    async login ({ getters, commit, dispatch }, payload) {
      const { data, errors } = await api.account.login(payload)
      if (!errors) {
        commit(SET_MODULES, data.modules)
        commit(SET_USER_TYPE, data.user_type)
        localStorage.setItem(TOKEN_KEY, data.token)
        setTimeout(() => { dispatch('verifyToken') }, 1000 * 60 * 25)
        if (!getters.isAdmin) {
          await dispatch('permissions/loadPermissions', null, { root: true })
        }
        commit(SET_AUTH, true)
      }

      return { data, errors }
    },

    logout ({ commit, dispatch }) {
      commit(SET_AUTH, false)
      localStorage.removeItem(TOKEN_KEY)
      localStorage.removeItem(USER_TYPE_KEY)
      localStorage.removeItem(MODULES_KEY)
      dispatch('permissions/clear', null, { root: true })
    },

    async verifyToken ({ dispatch }) {
      const token = localStorage.getItem(TOKEN_KEY)
      if (token && token !== 'undefined') {
        const { data, errors } = await api.account.verify({ token })
        return errors
          ? dispatch('refreshToken')
          : data.token
      }
      return false
    },

    async refreshToken ({ dispatch }) {
      const payload = { token: localStorage.getItem(TOKEN_KEY) }
      const { data, errors } = await api.account.refresh(payload)
      if (!errors) {
        localStorage.setItem(TOKEN_KEY, data.token)
        return true
      }
      dispatch('logout')
      return false
    },

    setTimezone ({ commit }, value) {
      commit(SET_TIMEZONE, value)
    },

    setLang ({ commit }, value) {
      Vue.i18n.set(value)
      commit(SET_LANG, value)
    }
  }
}
